import React from "react";
import moment from "moment";

const buttonClass =
  "px-2 py-1 bg-gray-100 text-xs rounded border border-gray-400 hover:bg-gray-200 text-gray-900 font-semibold";

class ChangeLogsStatus extends React.PureComponent {
  render() {
    const { changeLogs, isLogLoading, logFrom, handleView } = this.props;
    return (
      <div
        className={`rounded flex items-center gap-2 px-4 py-1 text-sm font-semibold ${
          changeLogs.length > 0
            ? "bg-orange-200 text-orange-700"
            : "bg-green-200 text-green-700"
        }`}
      >
        {isLogLoading ? (
          <div>Loading Change Logs ...</div>
        ) : (
          <>
            {changeLogs.length > 0
              ? `There are ${changeLogs.length} change logs.`
              : "No change log found "}
            {"["}
            {moment(logFrom).format("YYYY-MM-DD HH:mm Z")}
            {"~]"}
          </>
        )}

        {changeLogs.length > 0 && (
          <button className={buttonClass} onClick={handleView}>
            View Change Logs
          </button>
        )}
      </div>
    );
  }
}

export default ChangeLogsStatus;
